module.exports = __webpack_public_path__ + "static/media/truck-solid.6724ed61.svg";